package tables.placementCat

import emotion.react.css
import entities.Ad
import entities.PlacementCat
import kotlinx.browser.window
import models.CategoryModel
import models.PlacementCatModel
import org.w3c.fetch.RequestInit
import placementCatToJsonString
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.option
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.select
import react.useState
import token
import urlAddress
import web.cssom.*
import web.http.Headers

external interface UpdatePlacementCatProps : Props {
    var placementCatModel: PlacementCatModel?
    var onClose: () -> Unit
    var onUpdate: () -> Unit
    var listCat: List<CategoryModel>
    var listAd: List<Ad>
}

val UpdatePlacementCatModal = FC<UpdatePlacementCatProps> { props ->
    if (props.placementCatModel != null) {
        var catId by useState(props.listCat.first{it.name == props.placementCatModel!!.category}.id)
        var adId by useState(props.listAd.first{it.name == props.placementCatModel!!.ad}.id)
        var status by useState("")

        div {
            css {
                borderRadius = 10.px
                padding = 20.px
                position = Position.fixed
                top = 50.pct
                left = 50.pct
                transform = translate((-50).pct, (-50).pct)
                backgroundColor = rgb(142, 178, 170)
                display = Display.flex
                alignItems = AlignItems.center
                justifyContent = JustifyContent.center
            }

            div {
                div {
                    p {
                        +"Категория:"
                    }
                    div {
                        select {
                            value = catId
                            props.listCat.forEach {
                                option {
                                    value = it.id
                                    +it.name
                                }
                            }
                            onChange = {
                                catId = it.target.value.toInt()
                            }
                        }
                    }
                    p {
                        +"Реклама:"
                    }
                    div {
                        select {
                            value = adId
                            props.listAd.forEach {
                                option {
                                    value = it.id
                                    +it.name
                                }
                            }
                            onChange = {
                                adId = it.target.value.toInt()
                            }
                        }
                    }
                    div {
                        css {
                            paddingTop = 20.px
                            display = Display.flex
                            justifyContent = JustifyContent.spaceAround
                        }
                        button {
                            +"Сохранить"
                            val placementCat = PlacementCat(props.placementCatModel!!.id, catId, adId)
                            onClick = {
                                window.fetch(
                                    urlAddress + "api/placement", RequestInit(
                                        method = "PUT",
                                        headers = Headers().apply {
                                            append("Authorization", "Bearer $token")
                                            append("Content-Type", "application/json")
                                        },
                                        body = placementCatToJsonString(placementCat)
                                    )
                                )
                                    .then { response ->
                                        if (response.ok) {
                                            props.onClose()
                                            props.onUpdate()
                                        } else {
                                            status = "Ошибка"
                                        }
                                    }
                            }
                        }
                        button {
                            +"Отмена"
                            onClick = {
                                props.onClose()
                            }
                        }
                    }
                    p {
                        +status
                    }
                }
            }
        }
    }
}
